module.exports = __webpack_public_path__ + "images/stickers/pete-talk@2x.48607589629bafd9149a.png";